var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBtnCustomize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1L10.5981 4H8.75V7.25L12 7.25V5.40192L15 8L12 10.5981V8.75L8.75 8.75V12H10.5981L8 15L5.40192 12H7.25V8.75L4 8.75V10.5981L1 8L4 5.40192V7.25L7.25 7.25V4H5.40192L8 1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBtnCustomize);
export default __webpack_public_path__ + "static/media/icn_btn_customize.1e0cee38dfb34a2cb71fb357a97d3739.svg";
export { ForwardRef as ReactComponent };